// file-upload.component.ts
import { SmartusComponentsModule, ThemeOptions } from '@affinis/smartus-components';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  imports: [SmartusComponentsModule],
})
export class FileUploadComponent {
  @Input() disabled = false;

  @Input() accept = '';

  @Input() text = '';

  @Input() icon?: IconName;

  @Input() skin: ThemeOptions = 'primary';

  @Output() readonly fileSelected = new EventEmitter<File>();

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement?.files?.length) {
      this.fileSelected.emit(inputElement.files[0]);
      inputElement.value = '';
    }
  }
}
